import { Component, Input, TemplateRef } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { DelegatedLabeledComponent } from '../delegated-labeled.component';

@Component({
  selector: 'subs-checkbox',
  template: `
    <clr-checkbox-container [style]="safeContainerStyle">
      <label class="clr-col-12 clr-col-md-auto" [style]="safeLabelStyle"
        >{{ label }}
        <ng-container *ngIf="tooltip">
          <ng-container
            *ngTemplateOutlet="tooltip"
          ></ng-container> </ng-container
      ></label>
      <clr-checkbox-wrapper>
        <input
          class="clr-col-12 clr-col-md"
          type="checkbox"
          clrCheckbox
          name="controlName"
          [value]="true"
          [attr.disabled]="disabled"
          [formControlName]="controlName"
          [style]="safeInputStyle"
          [attr.data-test-id]="controlName"
        />
      </clr-checkbox-wrapper>
    </clr-checkbox-container>
  `,
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class CheckboxComponent extends DelegatedLabeledComponent {
  @Input() disabled: boolean;
  @Input() tooltip: TemplateRef<any>;
  constructor(sanitizer: DomSanitizer) {
    super(sanitizer);
  }
}
